/**
 * En-tête posé sur toute requête qui fait AGIR le bridge de caisse.
 *
 * Le bridge n'écoute que sur 127.0.0.1, donc aucun appareil du réseau ne
 * l'atteint. Le risque était plus étroit : une page web ouverte sur le Mac de
 * caisse pouvait l'appeler. Restreindre les origines côté bridge ne suffit pas,
 * car CORS ne bloque que la LECTURE de la réponse — un `POST` sans corps comme
 * `/epson/drawer` ou `/shutdown` partait quand même.
 *
 * Un en-tête PERSONNALISÉ force le navigateur à un contrôle préalable
 * (preflight), que le bridge refuse pour une origine inconnue. Ce n'est pas un
 * secret : sa seule valeur est de rendre la requête « non simple ».
 *
 * ⚠️ ORDRE DE DÉPLOIEMENT : ce front d'abord (un bridge ancien ignore
 * l'en-tête), le bridge ensuite. L'inverse casse les trois caisses.
 */
export const EN_TETE_BRIDGE = { 'X-Folies-Bridge': '1' } as const;

/** En-têtes d'un appel JSON au bridge. */
export const enTetesBridgeJson = (): Record<string, string> => ({
  'Content-Type': 'application/json',
  ...EN_TETE_BRIDGE,
});
